import { render, staticRenderFns } from "./PlacePickerG.vue?vue&type=template&id=37613bde"
import script from "./PlacePickerG.vue?vue&type=script&lang=ts"
export * from "./PlacePickerG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports